import { Loading } from "components";
import EmailVerification from "components/molecules/EmailVerification/EmailVerification";
import Header from "components/molecules/Header/Header";
import { Sidebar } from "components/molecules/Sidebar";
import jwt_decode from "jwt-decode";
import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { logout, resetAuthSlice } from "store/slices/auth.slice";
import { resetCardSlice } from "store/slices/card.slice";
import { getAllClients, getClientDTO } from "store/slices/client.slice";
import { resetSendAgain } from "store/slices/email.slice";
import { getFilters } from "store/slices/filters.slice";
import { resetListSlice } from "store/slices/list.slice";
import {
  resetTransactionsSlice,
  resetUpdateUser,
} from "store/slices/transactions.slice";
import { getPersonalInfo } from "store/slices/user.slice";
import EntryFormatter from "utils/EntryFormatter";
import { useChameleonIdentify } from "utils/hooks/useChameleonIdentify";
import { useTitlePage } from "utils/hooks/useTitlePage";

const Protected: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    data: user,
    isSuccess: isSuccessUser,
    isLoading,
  } = useAppSelector((state) => state.user);
  const {
    data: client,
    isLoading: clientIsLoading,
    isSuccess: clientIsSuccess,
  } = useAppSelector((state) => state.client);
  const { isSuccess, errorMessage, successMessage } = useAppSelector(
    (state) => state.email.sendAgain
  );
  const dispatch = useAppDispatch();
  const token = localStorage.getItem("accessToken");
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    dispatch(logout());
    dispatch(resetAuthSlice());
    dispatch(resetCardSlice());
    dispatch(resetListSlice());
    dispatch(resetTransactionsSlice());
    dispatch(resetUpdateUser());
  };
  let decodedToken: any;
  try {
    decodedToken = jwt_decode(token || "");
    if (Date.now() > decodedToken.exp * 1000) {
      decodedToken = false;
      handleLogout();
    }
  } catch (e) {
    localStorage.removeItem("accessToken");
    decodedToken = false;
  }
  const fetchFilters = () => {
    dispatch(getFilters({}));
  };
  useEffect(() => {
    fetchFilters();
  }, []);

  // const handleSendAgain = () => { if (token && !user.sentEmail) dispatch(resendVerificationEmail(token)); };
  useEffect(() => {
    if (!isSuccessUser) return;
    if (EntryFormatter.isObjectEmpty(user)) handleLogout();
  }, [user, isSuccessUser]);
  useEffect(() => {
    if (!errorMessage || !successMessage) return;
    if (errorMessage) toast.error(String(errorMessage));
    else if (successMessage) toast.success(successMessage);
    dispatch(resetSendAgain());
  }, [isSuccess]);
  useEffect(() => {
    if (EntryFormatter.isObjectEmpty(user)) dispatch(getPersonalInfo());
  }, []);
  useEffect(() => {
    if (
      !EntryFormatter.isObjectEmpty(user) &&
      !clientIsLoading &&
      !clientIsSuccess &&
      !client
    ) {
      dispatch(getClientDTO(user.clientId));
    }
  }, [user, clientIsSuccess]);
  useEffect(() => {
    if (user.isCoordinator) {
      dispatch(getAllClients());
    }
  }, [client, user, clientIsSuccess]);
  useTitlePage();
  useChameleonIdentify();

  if (!decodedToken) return <Navigate to={"/welcome"} />;

  if (location.pathname === "/onboarding") {
    return <Outlet />;
  }
  return (
    <div className="flex w-full h-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-col w-full h-full overflow-hidden">
        <Header isLoading={isLoading} loggedIn token={token || ""} />
        {!isLoading ? <Outlet /> : <Loading />}
      </div>
    </div>
  );
};

export default Protected;
